import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a entityservices - account
 * @param {*} state
 * @param {*} action
 */
export default function accountSearchReducer(state = initialState.accountSearch, action){

    switch(action.type)
    {
        case types.GET_ACCOUNT_REQUEST:
            return {...state, item: null, error: null, isSearching: true};
        case types.GET_ACCOUNT_SUCCESS:
            return {...state, item: action.data.account, error: null, isSearching: false};
        case types.GET_ACCOUNT_ERROR:
            return {...state, error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/accountSearchReducer.js